import {SpecialCategories} from './uploads';
import {dataFileUploadModuleFactory} from '../utils';

export default dataFileUploadModuleFactory(SpecialCategories.EMPLOYEES, {
   templateUrl: '/api/employees/excel-template',
});
